module.exports = "<div> <flexbox :margin-left=0> <flexbox-item v-for=\"(index, one) in list\" style=margin-left:0> <div class=item-{{index}}>{{one}}</div> </flexbox-item> </flexbox> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/demos/Flexbox.vue
 ** module id = 185
 ** module chunks = 0
 **/